'use client';

const fetchDoctors = async (zip: string, radius: string) => {
  const hostname: string =
    window?.location?.hostname?.replace(/^www\./, '') || 'localhost';

  let apiUrl = 'https://leads.organogenesis.dev';
  if (hostname === 'localhost') {
    apiUrl = 'https://leads.organogenesis.dev';
  } else if (hostname.endsWith('.com')) {
    apiUrl = 'https://leads.organogenesis.com';
  } else if (hostname.endsWith('.dev')) {
    apiUrl = 'https://leads.organogenesis.dev';
  }

  apiUrl = 'https://leads.organogenesis.com';

  const response = await fetch(
    `${apiUrl}/api/doctors?zip=${zip}&radius=${radius}`,
  );

  return response.json();
};

export { fetchDoctors };
